export default __webpack_public_path__ + "static/media/shape.f2554b05.svg";